import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, { filters = {}, pageNumber = 1, perPage } = {}) {
      const params = {
        ...filters,
        page: pageNumber,
      };

      if (perPage) {
        params.perPage = perPage;
      }

      const res = await axios.get(`${API_URL}/recipes`, { params });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, payload) {
      // Accepts either a plain recipeId (legacy calls) or { recipeId, withPrices }.
      // withPrices is opt-in: the backend only returns ingredient purchase prices when
      // explicitly requested (and only to roles that are allowed to see them).
      const recipeId = typeof payload === "object" ? payload.recipeId : payload;
      const withPrices = typeof payload === "object" ? payload.withPrices : false;

      const res = await axios.get(`${API_URL}/recipes/${recipeId}`, {
        params: withPrices ? { withPrices: 1 } : {},
      });

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOptions(_, criteria = {}) {
      const res = await axios.get(`${API_URL}/recipes/options`, {
        params: { perPage: 100, ...criteria },
      });

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      // Backend may return { items: [...] } or { data: [...] }
      return Array.isArray(res.data.items)
        ? res.data.items
        : Array.isArray(res.data.data)
          ? res.data.data
          : [];
    },

    async create(_, recipeData) {
      const res = await axios.post(`${API_URL}/recipes`, recipeData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { recipeId, recipeData }) {
      const res = await axios.put(`${API_URL}/recipes/${recipeId}`, recipeData);

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async delete(_, recipeId) {
      const res = await axios.delete(`${API_URL}/recipes/${recipeId}`);

      if (res.status !== 200 || !res.data || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async bulkRemove(_, recipeIds) {
      const res = await axios.delete(`${API_URL}/recipes/bulkDelete`, {
        data: { recipeIds },
      });

      if (res.status !== 200 || !res.data || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
